import React from 'react';

import PropTypes from 'prop-types';

import _isEmpty from 'lodash/isEmpty';

import './StyleRuleInheritance.scss';

const propTypes = {
  defaultValueInheritance: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeValueInheritance: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  activeValueInheritance: [],
};

export default function StyleRuleInheritance({ defaultValueInheritance, activeValueInheritance }) {
  function renderInheritance(inheritanceValues) {
    return inheritanceValues.map((aValue, index) => (
      <span key={`value-${aValue}`} className="value" style={{ marginLeft: `${index * 10}px` }}>
        {aValue}
      </span>
    ));
  }

  return (
    <div className="style-variable-inheritance">
      {!_isEmpty(defaultValueInheritance) && (
        <>
          <b>Default Value</b>
          <div>{renderInheritance(defaultValueInheritance)}</div>
        </>
      )}

      {!_isEmpty(activeValueInheritance) && (
        <>
          <b>Active Value</b>
          <div>{renderInheritance(activeValueInheritance)}</div>
        </>
      )}
    </div>
  );
}

StyleRuleInheritance.propTypes = propTypes;
StyleRuleInheritance.defaultProps = defaultProps;
